export var COMMON_PREFERENCE_TYPES;
(function (COMMON_PREFERENCE_TYPES) {
    COMMON_PREFERENCE_TYPES["CRQLAR_FOOD_TYPE"] = "CRQLAR_FOOD_TYPE";
    COMMON_PREFERENCE_TYPES["CRQLAR_FOOD_ALLERGY"] = "CRQLAR_FOOD_ALLERGY";
    COMMON_PREFERENCE_TYPES["CRQLAR_TRAVELING_WITH_PET"] = "CRQLAR_TRAVELING_WITH_PET";
    COMMON_PREFERENCE_TYPES["CRQLAR_INTERESTS"] = "CRQLAR_INTERESTS";
    COMMON_PREFERENCE_TYPES["CRQLAR_AI_GENERATED_INTERESTS"] = "CRQLAR_AI_GENERATED_INTERESTS";
    COMMON_PREFERENCE_TYPES["CRQLAR_MEDICAL"] = "CRQLAR_MEDICAL";
    COMMON_PREFERENCE_TYPES["CRQLAR_PILLOW_TYPE"] = "CRQLAR_PILLOW_TYPE";
    COMMON_PREFERENCE_TYPES["CRQLAR_BED_TYPE"] = "CRQLAR_BED_TYPE";
    COMMON_PREFERENCE_TYPES["CRQLAR_VIEW_TYPE"] = "CRQLAR_VIEW_TYPE";
    COMMON_PREFERENCE_TYPES["CRQLAR_ACCESSIBILITY"] = "CRQLAR_ACCESSIBILITY";
    COMMON_PREFERENCE_TYPES["CRQLAR_AMENITIES"] = "CRQLAR_AMENITIES";
    COMMON_PREFERENCE_TYPES["CRQLAR_OTHER"] = "CRQLAR_OTHER";
    COMMON_PREFERENCE_TYPES["OTA_LOYALTY"] = "OTA_LOYALTY";
    COMMON_PREFERENCE_TYPES["OTA_ROOM_AMENITY"] = "OTA_ROOM_AMENITY";
    COMMON_PREFERENCE_TYPES["OTA_PAYMENT_FORM"] = "OTA_PAYMENT_FORM";
    COMMON_PREFERENCE_TYPES["OTA_HOTEL_CHAIN"] = "OTA_HOTEL_CHAIN";
    COMMON_PREFERENCE_TYPES["OTA_PROPERTY_NAME"] = "OTA_PROPERTY_NAME";
    COMMON_PREFERENCE_TYPES["OTA_PROPERTY_LOCATION"] = "OTA_PROPERTY_LOCATION";
    COMMON_PREFERENCE_TYPES["OTA_PROPERTY_TYPE"] = "OTA_PROPERTY_TYPE";
    COMMON_PREFERENCE_TYPES["OTA_PROPERTY_CLASS"] = "OTA_PROPERTY_CLASS";
    COMMON_PREFERENCE_TYPES["OTA_PROPERTY_AMENITY"] = "OTA_PROPERTY_AMENITY";
    COMMON_PREFERENCE_TYPES["OTA_ROOM_LOCATION"] = "OTA_ROOM_LOCATION";
    COMMON_PREFERENCE_TYPES["OTA_BED_TYPE"] = "OTA_BED_TYPE";
    COMMON_PREFERENCE_TYPES["OTA_FOOD_SERVICE"] = "OTA_FOOD_SERVICE";
    COMMON_PREFERENCE_TYPES["OTA_MEDIA_ENTERTAINMENT"] = "OTA_MEDIA_ENTERTAINMENT";
    COMMON_PREFERENCE_TYPES["OTA_PET_INFO"] = "OTA_PET_INFO";
    COMMON_PREFERENCE_TYPES["OTA_MEAL"] = "OTA_MEAL";
    COMMON_PREFERENCE_TYPES["OTA_RECREATION_SERVICE"] = "OTA_RECREATION_SERVICE";
    COMMON_PREFERENCE_TYPES["OTA_BUSINESS_SERVICE"] = "OTA_BUSINESS_SERVICE";
    COMMON_PREFERENCE_TYPES["OTA_PERSONAL_SERVICE"] = "OTA_PERSONAL_SERVICE";
    COMMON_PREFERENCE_TYPES["OTA_SECURITY_FEATURE"] = "OTA_SECURITY_FEATURE";
    COMMON_PREFERENCE_TYPES["OTA_SPECIAL_REQUEST"] = "OTA_SPECIAL_REQUEST";
})(COMMON_PREFERENCE_TYPES || (COMMON_PREFERENCE_TYPES = {}));
/**
 * The options staff pick from. The first 14 are the EU allergens; the rest are what staff wrote most, as free text
 * or in notes, in production (10-2026). Stored values are these keys; a removed key keeps its label.
 * Mirrored by the API's `AllergyV3`.
 */
export var Allergy;
(function (Allergy) {
    Allergy["MILK"] = "MILK";
    Allergy["TREE_NUTS"] = "TREE_NUTS";
    Allergy["EGGS"] = "EGGS";
    Allergy["PEANUTS"] = "PEANUTS";
    Allergy["FISH"] = "FISH";
    Allergy["WHEAT"] = "WHEAT";
    Allergy["SHELLFISH"] = "SHELLFISH";
    Allergy["SOYBEANS"] = "SOYBEANS";
    Allergy["CELERY"] = "CELERY";
    Allergy["MUSTARD"] = "MUSTARD";
    Allergy["SESAME"] = "SESAME";
    Allergy["SULPHITES"] = "SULPHITES";
    Allergy["LUPIN"] = "LUPIN";
    Allergy["MOLLUSCS"] = "MOLLUSCS";
    Allergy["LACTOSE"] = "LACTOSE";
    Allergy["GARLIC"] = "GARLIC";
    Allergy["PAPRIKA"] = "PAPRIKA";
    Allergy["FRUCTOSE"] = "FRUCTOSE";
    Allergy["ONION"] = "ONION";
    Allergy["RAW_FRUIT"] = "RAW_FRUIT";
    Allergy["CITRUS"] = "CITRUS";
    Allergy["TOMATO"] = "TOMATO";
    Allergy["MUSHROOMS"] = "MUSHROOMS";
    Allergy["HISTAMINE"] = "HISTAMINE";
    Allergy["FEATHERS"] = "FEATHERS";
    Allergy["ANIMAL_HAIR"] = "ANIMAL_HAIR";
    Allergy["DUST_MITES"] = "DUST_MITES";
})(Allergy || (Allergy = {}));
/** Paleo, raw food and keto were dropped (no real use in production, 10-2026); guests who have them keep them. */
export var DietType;
(function (DietType) {
    DietType["VEGETARIAN"] = "VEGETARIAN";
    DietType["VEGAN"] = "VEGAN";
    DietType["PESCATARIAN"] = "PESCATARIAN";
    DietType["GLUTEN_FREE"] = "GLUTEN_FREE";
    DietType["LACTOSE_FREE"] = "LACTOSE_FREE";
    DietType["LOW_CARB"] = "LOW_CARB";
    DietType["HALAL"] = "HALAL";
    DietType["KOSHER"] = "KOSHER";
    DietType["NO_ALCOHOL"] = "NO_ALCOHOL";
    DietType["NO_PORK"] = "NO_PORK";
})(DietType || (DietType = {}));
/** Medical options, chosen for spa treatments; staff can still add their own. Labels: "Common health preference value <KEY>". */
export var MedicalCondition;
(function (MedicalCondition) {
    MedicalCondition["PREGNANT"] = "PREGNANT";
    MedicalCondition["DIABETES"] = "DIABETES";
    MedicalCondition["HYPERTENSION"] = "HYPERTENSION";
    MedicalCondition["BACK_NECK"] = "BACK_NECK";
    MedicalCondition["ASTHMA"] = "ASTHMA";
    MedicalCondition["MOBILITY"] = "MOBILITY";
    MedicalCondition["HEARING_SIGHT"] = "HEARING_SIGHT";
    MedicalCondition["SURGERY"] = "SURGERY";
    MedicalCondition["CANCER"] = "CANCER";
})(MedicalCondition || (MedicalCondition = {}));
/** Mirrored by the API's `InterestV3`. */
export var Interest;
(function (Interest) {
    Interest["MASSAGES"] = "MASSAGES";
    Interest["SPA_BEAUTY"] = "SPA_BEAUTY";
    Interest["FINE_DINING"] = "FINE_DINING";
    Interest["CULTURE"] = "CULTURE";
    Interest["SIGHTSEEING"] = "SIGHTSEEING";
    Interest["HIKING"] = "HIKING";
    Interest["BIKING"] = "BIKING";
    Interest["FAMILY"] = "FAMILY";
    Interest["COUPLE"] = "COUPLE";
    Interest["SKIING"] = "SKIING";
    Interest["DOGS"] = "DOGS";
    Interest["HORSE_RIDING"] = "HORSE_RIDING";
    Interest["YOGA"] = "YOGA";
    Interest["WINE"] = "WINE";
    Interest["GOLF"] = "GOLF";
    Interest["BUSINESS"] = "BUSINESS";
    Interest["TENNIS"] = "TENNIS";
    Interest["FITNESS"] = "FITNESS";
    Interest["CELEBRATIONS"] = "CELEBRATIONS";
})(Interest || (Interest = {}));
